export const WhatsAppContactConsultor =
  "https://api.whatsapp.com/send?phone=551199490-4779&text=Quero%20falar%20com%20um%20consultor%20Strm";

export const WhatsAppContactDistro =
  "https://api.whatsapp.com/send?phone=551199490-4779&text=Quero%20distribuir%20meus%20pr%C3%B3ximos%20lan%C3%A7amentos%20com%20voc%C3%AAs";

export const WhatsAppContactAdvance =
  "https://api.whatsapp.com/send?phone=551199490-4779&text=Tenho%20adiantamento%20disponível%20e%20estou%20interessado(a).%20Quero%20tirar%20dúvidas%20com%20um%20consultor%20por%20favor";
